/**
 * Pluralizes a word based on the count.
 * If the count is 1, it returns "1 <word>".
 * Otherwise, it returns "<count> <word>s".
 *
 * @param word - The word to pluralize.
 * @param count - The count to determine the pluralization.
 * @returns The pluralized word.
 */
export function pluralizeWord(
  word: string,
  count: number,
  order: 'after' | 'before' | 'hideNumber' = 'after',
  pluralWord: string | undefined = undefined
): string {
  const finalPluralWord = pluralWord ?? `${word}s`
  const pluralizedWord = count === 1 ? word : finalPluralWord

  if (order === 'hideNumber') {
    return pluralizedWord
  }

  return order === 'after' ? `${count} ${pluralizedWord}` : `${pluralizedWord} ${count}`
}
